import { ActionDialog } from '@/modules/events/views/EventManager/types';
import { EventStatusEnum } from '@/types/schema';

import ArchiveSessionDialog from '../ArchiveSessionDialog';
import RescheduleSessionModal from '../RescheduleSessionModal';
import ShareSessionDialog from '../ShareSessionDialog';

export const TAGS = {
  [EventStatusEnum.Completed]: { appearance: 'secondary', label: 'Common:Filter.Finished' },
  [EventStatusEnum.Archived]: { appearance: 'secondary', label: 'Common:Filter.Canceled' },
  [EventStatusEnum.Revoked]: { appearance: 'secondary', label: 'Common:Filter.Revoked' },
};

export const eventActionComponentsRegistry = {
  [ActionDialog.Archive]: ArchiveSessionDialog,
  [ActionDialog.Reschedule]: RescheduleSessionModal,
  [ActionDialog.Share]: ShareSessionDialog,
};
